var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Navbar', {
    attrs: {
      "nav-light": true
    }
  }), _c('section', {
    staticClass: "bg-half bg-primary d-table w-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('div', {
    staticClass: "page-next-level"
  }, [_c('h4', {
    staticClass: "title text-white",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("reporting.monthly")) + " ")])])])])])]), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container card public-profile border-0 rounded shadow overflow-hidden"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "text-center uppercase"
  }, [_vm._v(_vm._s(_vm.$t("reporting.monthly")) + " - " + _vm._s(_vm.$t("wasiat1")))]), _c('h6', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toHumanDate")(_vm.currentMonth)))]), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "staticEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t("month")))]), _c('div', {
    staticClass: "col-sm-8 col-md-4 col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentMonth,
      expression: "currentMonth"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "month",
      "name": "",
      "id": ""
    },
    domProps: {
      "value": _vm.currentMonth
    },
    on: {
      "change": _vm.monthChange,
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.currentMonth = $event.target.value;
      }
    }
  })])])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-4 col-form-label",
    attrs: {
      "for": "staticEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t("organization")))]), _c('div', {
    staticClass: "col-sm-8 col-md-8 col-lg-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedOrganization,
      expression: "selectedOrganization"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "disabled": _vm.userRole != 'Staff'
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedOrganization = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.onOrganizationChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("all-org")))]), _vm._l(Object.entries(this.organizations), function (type, index) {
    return _c('optgroup', {
      key: index,
      attrs: {
        "label": type[0]
      }
    }, _vm._l(type[1], function (organization, index2) {
      return _c('option', {
        key: index2,
        domProps: {
          "value": organization.id
        }
      }, [_vm._v(" " + _vm._s(organization.name) + " ")]);
    }), 0);
  })], 2)])])]), _vm.selectedOrganization != '' ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-4 col-form-label",
    attrs: {
      "for": "staticEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t("org.nav2")))]), _c('div', {
    staticClass: "col-sm-8 col-md-8 col-lg-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedBranch,
      expression: "selectedBranch"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "disabled": _vm.userRole == 'Admin'
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedBranch = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.getWasiats]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("all-branch")))]), _vm._l(_vm.branches, function (branch, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v(" " + _vm._s(branch.branch_name) + " ")]);
  })], 2)])])]) : _vm._e()]), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("no-of-wills")) + ": " + _vm._s(_vm.pagination.totalRows))])])])]), _c('div', {
    staticClass: "table-responsive bg-white shadow rounded mt-2"
  }, [_c('table', {
    staticClass: "table mb-0 table-center",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('thead', {
    staticClass: "bg-light"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("index")))]), _c('th', [_vm._v(_vm._s(_vm.$t("amendment.no-wasiat")))]), _c('th', [_vm._v(_vm._s(_vm.$t("date-of-will")))]), _c('th', [_vm._v(_vm._s(_vm.$t("testator-name")))]), _c('th', [_vm._v(_vm._s(_vm.$t("referral-no")))]), _c('th', [_vm._v(_vm._s(_vm.$t("testator-mykad")))]), _c('th', [_vm._v(_vm._s(_vm.$t("business-partner")))]), _c('th', [_vm._v(_vm._s(_vm.$t("org.nav2")))]), _c('th', [_vm._v(_vm._s(_vm.$t("agent-name")))]), _c('th', [_vm._v(_vm._s(_vm.$t("wasiatasas.price")))])])]), _c('tbody', [_vm._m(0), _vm._l(_vm.wasiats, function (wasiat, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s((_vm.pagination.currentPage - 1) * _vm.pagination.perPage + index + 1) + " ")]), _c('td', [_vm._v(_vm._s(wasiat.wasiat_no))]), _c('td', [_vm._v(_vm._s(_vm._f("formatDateTime")(wasiat.created_at)))]), _c('td', [_vm._v(_vm._s(wasiat.user.name))]), _c('td', [_vm._v(_vm._s(wasiat.referrer_number))]), _c('td', [_vm._v(_vm._s(wasiat.user.ic_number))]), _c('td', [_vm._v(" " + _vm._s(wasiat.organization ? wasiat.organization.name : "-") + " ")]), _c('td', [_vm._v(" " + _vm._s(wasiat.branch ? wasiat.branch.branch_name : "-") + " ")]), _c('td', [_vm._v(_vm._s(wasiat.agent ? wasiat.agent.name : "-"))]), _c('td', [_vm._v("RM " + _vm._s(wasiat.price))])]);
  }), _vm.wasiats && _vm.wasiats.length == 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('h6', {
    staticClass: "mt-5 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("wasiatasas.no-will")))])])]) : _vm._e()], 2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-7"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.totalRows,
      "per-page": _vm.pagination.perPage,
      "aria-controls": "my-table"
    },
    on: {
      "change": _vm.pageClicks
    },
    model: {
      value: _vm.pagination.currentPage,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v);
      },
      expression: "pagination.currentPage"
    }
  })], 1), _c('div', {
    staticClass: "col-lg-3 col-md-5 mt-4 mt-sm-0 pt-2 pt-sm-0"
  }, [_c('div', {
    staticClass: "form custom-form"
  }, [_c('div', {
    staticClass: "form-group mb-0"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pagination.perPage,
      expression: "pagination.perPage"
    }],
    staticClass: "form-control custom-select",
    attrs: {
      "id": "Sortbylist-job"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.pagination, "perPage", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.changePerPage();
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "200"
    }
  }, [_vm._v("200 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "300"
    }
  }, [_vm._v("300 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "400"
    }
  }, [_vm._v("400 " + _vm._s(_vm.$t("per-page")))])])])])])])])])]), _c('Footer'), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: '#topnav',
      expression: "'#topnav'"
    }],
    staticClass: "btn btn-icon btn-soft-primary back-to-top",
    attrs: {
      "href": "javascript: void(0);",
      "id": "back-to-top"
    }
  }, [_c('arrow-up-icon', {
    staticClass: "icons"
  })], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  })]);
}]

export { render, staticRenderFns }